import { utils } from "@sundae/wallets";
/* eslint-disable @typescript-eslint/no-explicit-any */
const DEFAULT_ERROR_MESSAGE = "Something went wrong. See error in the console.";
export const displayError = async (error) => {
    console.log(error);
    if (typeof error === "string")
        return error;
    if (utils.isCIPErrorWithCode(error))
        return error.info;
    if (error?.code && error.message) {
        return error.message;
    }
    if (error instanceof Error) {
        return error.message ?? DEFAULT_ERROR_MESSAGE;
    }
    return DEFAULT_ERROR_MESSAGE;
};
//# sourceMappingURL=displayError.js.map